import { useEffect, useState } from "react";
import { useVendingData } from "../../hooks/useVendingData";
import VendingTable from "./VendingTable/VendingTable";
import WalletTable from "./WalletTable/WalletTable";
import OutlineButton from "../UIKits/OutlineButton/OutlineButton";
import "./HomeTablesContainer.scss";
import { useNavigate } from "react-router-dom";
import { useWalletData } from "../../hooks/useWalletData";
import { usePowerPurchaseStore } from "../../store/buyPowerStore";

const HomeTablesContainer = () => {
  const [currentTable, setCurrentTable] = useState(0);
  const navigate = useNavigate();
  const refetchKey = usePowerPurchaseStore((state) => state.refetchKey);

 // Fetch data without filters
  const vendingDataHook = useVendingData({ 
    autoFetch: currentTable === 0, // Only fetch when active
    pageSize: 5, // Show only 5 on home page
    enableFilters: false // Disable filters for home page
  });

  const walletDataHook = useWalletData({ 
    autoFetch: currentTable === 1, // Only fetch when active
    pageSize: 5,
    enableFilters: false
  });
const handleTabSwitch = (tabIndex: number) => {
    setCurrentTable(tabIndex);
    
    // Fetch data for the active tab
    if (tabIndex === 0) {
      vendingDataHook.refetch();
    } else {
      walletDataHook.refetch();
    }
  };

  useEffect(() => {
    if (refetchKey > 0) {
      if (currentTable === 0) {
        vendingDataHook.refetch();
      } else {
        walletDataHook.refetch();
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refetchKey, currentTable]);
  const viewAll = () => {
     
    navigate("/self-service-report");
  };

  return (
    <div className="home-tables-container w-full mx-auto overflow-hidden  ">
      <div className="w-full flex items-center gap-3">
        <OutlineButton
          label="Vending"
          filterMobileButton={true}
          onClick={() => handleTabSwitch(0)}
          className={`${currentTable === 0 ? "!bg-darkGreen !text-white" : ""}`}
        />

        <OutlineButton
          label="Wallet"
          filterMobileButton={true}
          onClick={() => handleTabSwitch(1)}
          className={`!px-6  ${currentTable === 1 ? "!bg-darkGreen !text-white" : "!bg-ashbg"}`}
        />
      </div>
      <div>{currentTable === 0 ? <VendingTable vendingDataHook={vendingDataHook}  showViewAll={true} /> : <WalletTable walletDataHook={walletDataHook} showViewAll={true} />}</div>
      <div className="border-b w-full mb-4"></div>
      <div className="rounded-lg     cursor-pointer  w-full  text-center bg-[#EEEEEE] p-2  " onClick={viewAll}>
        View all
      </div>
    </div>
  );
};

export default HomeTablesContainer;
